module.exports = __webpack_public_path__ + "public/images/darkphoto.59efb0af2355e2d921b7bba956a527cd.svg";